import { Layout } from "@singularsystems/neo-canvas-grid";
import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import IssuerAccrualCriteria from "./IssuerAccrualCriteria";

@NeoReport("IssuerAccrual", { category: ReportCategory.IssuerReports })
export default class IssuerAccrualReport extends Report<IssuerAccrualCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(IssuerAccrualCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2} lg={3}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.entityId} select={{itemSource: this.dataCache.entities}} />
                </div>
            </Neo.GridLayout>
        </div>;
    }

    public getDefaultGridLayout(criteria?: IssuerAccrualCriteria | undefined, propertyKey?: string | undefined): Layout.IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "accrual.averageRate",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "accrual.averageCapital"
                        }
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}